import React from "react";
import { useTranslation } from "react-i18next";

//MUI Icons
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

//Custom Components
import TableButton from "./TableButton";

//Types
import { ITableActionButtonDetail } from "@/@types/ui/Table";

function TableButtonApprove(props: ITableActionButtonDetail) {
  const { t } = useTranslation();

  return (
    <TableButton startIcon={<AssignmentTurnedInIcon/>} allow="one" selection={[]} {...props}>
     {t('buttons.approve_excursion')}
    </TableButton>
  );
}

export default TableButtonApprove;
